import BackButton from '@components/shared/essential-ui/back-button/BackButton';
import { Typography } from '@components/style/Typography';
import { theme } from '@theme';
import { FC } from 'react';
import styled from 'styled-components';

type NoDealsheetResultPageProps = {
  message: string;
};

const NoDealsheetResultPage: FC<NoDealsheetResultPageProps> = (props) => (
  <Wrapper data-testid='error-deal-sheet-page'>
    <tbody>
      <tr>
        <td>
          <Typography
            size={theme.typography.h3}
            color={theme.palette.dusty}
            fontWeight={theme.typography.fontWeights.semibold}
          >
            {props.message}
          </Typography>
        </td>
      </tr>
      <tr>
        <td>
          <BackButton marginLeft={0} />
        </td>
      </tr>
    </tbody>
  </Wrapper>
);

const Wrapper = styled.table`
  width: 100%;
  height: 20rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 90px;
  color: ${(props) => props.theme.palette.lightGray};

  & tr:last-child {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export default NoDealsheetResultPage;
